module.exports = __webpack_public_path__ + "img/consult_info2.61be5863.png";